import _pick from "lodash/pick";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet } from 'react-native';
import View from 'react-native-web-ui-components/View';
import StylePropType from 'react-native-web-ui-components/StylePropType';
import TimeRangePicker, { NUMBER_DECODER, NUMBER_ENCODER, STRING_DECODER, STRING_ENCODER } from 'react-native-web-ui-components/TimeRangePicker';
import { useOnChange, useAutoFocus } from '../utils';
const styles = StyleSheet.create({
  empty: {},
  defaults: {
    marginBottom: 10
  },
  fullWidth: {
    width: '100%'
  },
  auto: {
    marginBottom: 0
  },
  marginTop: {
    marginTop: -10
  }
});
const timePickerAttributes = ['minTime', 'maxTime', 'interval', 'filterTime', 'selectedStyle', 'unselectedStyle'];

const TimeRangeWidget = props => {
  const {
    schema,
    uiSchema,
    hasError,
    name,
    value,
    readonly,
    disabled,
    auto,
    encoder,
    decoder,
    header,
    style,
    ...nextProps
  } = props;
  const autoFocusParams = useAutoFocus(props);
  const onChange = useOnChange(props);
  const currentStyle = [styles.defaults, auto ? styles.auto : styles.fullWidth];

  if (header) {
    currentStyle.push(styles.marginTop);
  }

  currentStyle.push(style);

  const timePickerProps = _pick(nextProps, timePickerAttributes);

  timePickerProps.header = header;

  if (encoder !== null) {
    if (encoder === 'number') {
      timePickerProps.encoder = NUMBER_ENCODER;
      timePickerProps.decoder = NUMBER_DECODER;
    } else if (encoder === 'string') {
      timePickerProps.encoder = STRING_ENCODER;
      timePickerProps.decoder = STRING_DECODER;
    } else {
      timePickerProps.encoder = encoder;
      timePickerProps.decoder = decoder;
    }
  }

  return /*#__PURE__*/React.createElement(View, {
    style: currentStyle
  }, /*#__PURE__*/React.createElement(TimeRangePicker, _extends({}, timePickerProps, autoFocusParams, {
    name: name,
    hasError: hasError,
    disabled: disabled,
    readonly: readonly,
    value: value,
    onChange: onChange
  })));
};

TimeRangeWidget.propTypes = {
  schema: PropTypes.shape({}).isRequired,
  uiSchema: PropTypes.shape({}).isRequired,
  hasError: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  readonly: PropTypes.bool,
  disabled: PropTypes.bool,
  auto: PropTypes.bool,
  style: StylePropType,
  encoder: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  decoder: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  header: PropTypes.bool
};
TimeRangeWidget.defaultProps = {
  value: null,
  readonly: false,
  disabled: false,
  auto: false,
  style: null,
  encoder: null,
  decoder: null,
  header: true
};
export default TimeRangeWidget;